import '../styles/document.css';
import React from "react";
import {Link, useNavigate} from "react-router-dom";
import styles from "../styles/layout/layout.module.css";
import {getLogo} from "../utils/helper";

function Impressum(props) {
    const navigator = useNavigate();

    return (

        <div className={"container-home"}>

            <div className={"container"}>
                <div className="section menu bg-black-10 text-center ">

                    <div className={"container-doc"}>


                        <div className="back-to-home" onClick={
                            () => navigator("/")
                        }>
                            {getLogo(2)}
                        </div>
                        <h1>
                            Impressum
                        </h1>
                        <h2>
                            Kando GmbH
                        </h2>
                        <ul>
                            <li>
                                • Am Bahnhof 3 09599 Freiberg •
                            </li>
                        </ul>
                        <ul>
                            <li>
                                Kontakt:
                            </li>
                            <li> Tel.: +4937312188290</li>
                            <li>E-Mail: info.kando.freiberg@gmail.com</li>
                            <li>Geschäftsführer: Nguyen, Huu Chuan</li>
                            <li>Handelsregister: HRB 35974</li>
                            <li>Registergericht: Amtsgericht Chemnitz</li>
                            <li>Umsatzsteuer-ID</li>
                            <li>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE 362814482</li>
                        </ul>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Impressum;